import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as getCatalogActions from "../../slices/catalog/getCatalog.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
var lastCatalogErrorKey = "";
export var getCatalog = function(payload) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, modalObj = _ref.modalObj, setModalObj = _ref.setModalObj, _ref_silentError = _ref.silentError, silentError = _ref_silentError === void 0 ? false : _ref_silentError;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var requestKey, result, error, statusCode, errorMessage, _error_response_data, errorKey;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestKey = JSON.stringify(payload || {});
                        dispatch(getCatalogActions.fetchData(requestKey));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            http({
                                method: "post",
                                url: endPoint.ALL_CATALOG,
                                data: payload
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        lastCatalogErrorKey = "";
                        dispatch(getCatalogActions.fetchDataSuccess({
                            requestKey: requestKey,
                            data: result.data
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        statusCode = 500;
                        errorMessage = "เกิดข้อผิดพลาด";
                        if (http.isAxiosError(error) && error.response) {
                            ;
                            statusCode = error.response.status;
                            errorMessage = ((_error_response_data = error.response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || errorMessage;
                        }
                        errorKey = "".concat(statusCode, "-").concat(errorMessage);
                        if (!silentError && lastCatalogErrorKey !== errorKey && setModalObj) {
                            lastCatalogErrorKey = errorKey;
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส ".concat(statusCode),
                                navigateDirection: undefined,
                                title: errorMessage
                            }));
                        }
                        dispatch(getCatalogActions.fetchDataFailure(requestKey));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
